/**
 * Created by colinjlacy on 4/14/16.
 */
import {Component, Input} from '@angular/core';
import { prebootComplete } from "angular2-universal";

@Component({
    selector: 'loading-indicator',
    template: 
        `
        <div [ngSwitch]="type">
            <div *ngSwitchCase="'spinner'" class="spinner">
                <div [ngStyle]="{'background-color': color}" class="rect1"></div>
                <div [ngStyle]="{'background-color': color}" class="rect2"></div>
                <div [ngStyle]="{'background-color': color}" class="rect3"></div>
                <div [ngStyle]="{'background-color': color}" class="rect4"></div>
                <div [ngStyle]="{'background-color': color}" class="rect5"></div>
            </div>
            <div *ngSwitchCase="'cube'" class="sk-cube-grid">
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube1"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube2"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube3"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube4"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube5"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube6"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube7"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube8"></div>
                <div [ngStyle]="{'background-color': color}" class="sk-cube sk-cube9"></div>
            </div>
        </div>
        `,

        styles: [require('./assets/css/spinner.css')]
})
export class LoadingIndicator {

    @Input() color;
    @Input() type = 'spinner';

}

export class LoadingPage {
    public loading: boolean;
    constructor(val: boolean) {
        this.loading = val;
    }
    standby() {
        this.loading = true;
    }
    ready() {
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof prebootComplete != 'undefined') {
            prebootComplete();
        }
        this.loading = false;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/loading-indicator.ts